<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">{{title}}</span>
      </caption>
      <colgroup>
        <col width="200px"/>
        <col width="75px" />
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">{{divName}}</th>
          <th rowspan="2">대상자수</th>
          <th colspan="5">두뇌톡톡</th>
          <th colspan="4">기억검사</th>
          <th colspan="4">기억검사 단계별 대상자수</th>
        </tr>
        <tr>
          <th>호출건수</th>
          <th>이용자수</th>
          <th>완료건수</th>
          <th>완료자수</th>
          <th>평균점수</th>
          <th>호출건수</th>
          <th>이용자수</th>
          <th>완료건수</th>
          <th>완료자수</th>
          <th>1단계</th>
          <th>2단계</th>
          <th>3단계</th>
          <th>4단계</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <TableRow
        :item="rowData.item"
        :rcpCount="rowData.rcpCount"
        :gameUseBrain="rowData[`${listKey}GameUseBrain`]"
        :gameUseDementia="rowData[`${listKey}GameUseDementia`]"
        :gameUseDementiaStep="rowData[`${listKey}GameUseDementiaStep`]"
      />
    </template>
  </PlainTable>
</template>

<script>
import TableRow from "./ItemTable.row";

export default {
  components: { TableRow },
  props: {
    title: String,
    listKey: String,
    itemArray: Array,
    divName: String
  }
};
</script>